export enum AppType {
  Exam = 'exam',
  Matura = 'matura',
}
